import getComposerSelectorOptionsObject from '@/redux/selectors/pieveSelectors/lib/getComposerSelectorOptionsObject.js';
import normalizeResolvedComposerSurfaceMode from '@/redux/selectors/pieveSelectors/lib/normalizeResolvedComposerSurfaceMode.js';

const getComposerSelectorSurfaceMode = (options) => {
  return normalizeResolvedComposerSurfaceMode(getComposerSelectorOptionsObject(options)?.surfaceMode);
};

export default getComposerSelectorSurfaceMode;
